import axios from 'axios';

const getNameConventions = () => {
  return axios.get('/api/name-conventions/forge');
};

const editNameConvention = (data, config) => {
  return axios.put('/api/name-conventions/forge', data, config);
};

export {
  getNameConventions,
  editNameConvention,
};
